import { create } from 'zustand'
import type { Notification } from '@shared/types/notification.types'
import { mockNotifications } from '@shared/data/mock-notifications'

interface NotificationState {
  notifications: Notification[]
  unreadCount: number
}

interface NotificationActions {
  markAsRead: (id: string) => void
  markAllAsRead: () => void
  dismissNotification: (id: string) => void
}

const computeUnread = (notifications: Notification[]) =>
  notifications.filter((n) => !n.read).length

export const useNotificationStore = create<NotificationState & NotificationActions>((set) => ({
  notifications: mockNotifications,
  unreadCount: computeUnread(mockNotifications),

  markAsRead: (id) =>
    set((state) => {
      const notifications = state.notifications.map((n) =>
        n.id === id ? { ...n, read: true } : n
      )
      return { notifications, unreadCount: computeUnread(notifications) }
    }),

  markAllAsRead: () =>
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, read: true })),
      unreadCount: 0,
    })),

  dismissNotification: (id) =>
    set((state) => {
      const notifications = state.notifications.filter((n) => n.id !== id)
      return { notifications, unreadCount: computeUnread(notifications) }
    }),
}))
